<template>
  <v-col v-if="metadataSelectGroupPending" cols="12" md="6">
    <v-skeleton-loader type="text" />
  </v-col>
  <ProjectsMetadataSelect
    v-for="(metadataObj, key) in metadata"
    :key="key"
    :metadataLabel="metadataObj.label"
    :metadataOptions="metadataObj.values"
    :model-value="getMetadataValue(key)"
    :disabled="isSelectDisabled()"
    @update:modelValue="updateMetadataValue(key, $event)"
  />
</template>

<script lang="ts">
import {mapState} from "vuex";

import roomsService from '@/services/rooms.service'

import ProjectsMetadataSelect from './ProjectsMetadataSelect.vue'


type Metadata = {
  label: string
  values: { key: string; label: string }[]
}
type Room = {
  name: string
  type: number | null
  optHideGroups?: boolean
  optAllowGuestBibles?: boolean
  expClosingDate: Date | null
  cmRef: string
  labelId: number | null
  metadata?: Record<string, string>
  subscription: any
}

type DataRoom = Room & {
  duration: number | null
  storage: number | null
  unit: string | null
  displayWatermark: boolean
}

type RoomType = Room | DataRoom

export default {
  name: 'ProjectsMetadataSelectGroup',
  components: {
    ProjectsMetadataSelect,
  },
  props: {
    room: {
      type: Object as () => RoomType,
      required: true,
    },
    settingsPage: {
      type: Boolean,
      required: false,
      default: false,
    },
    mnemo: {
      type: String,
      required: true,
    },
    modelValue: {
      type: Object as () => Record<string, string>,
      required: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      metadata: {} as Record<string, Metadata>,
      metadataSelectGroupPending: true,
    }
  },
  computed: {
    ...mapState('user', ['profile']),
  },
  methods: {
    getMetadataValue(key: string): string {
      return this.modelValue?.[key] ?? this.room.metadata?.[key] ?? ''
    },
    updateMetadataValue(key: string, val: string) {
      if (this.modelValue) {
        const updatedMetadata = { ...this.modelValue }
        updatedMetadata[key] = val
        this.$emit('update:modelValue', updatedMetadata)
      } else {
        if (!this.room.metadata) this.room.metadata = {}
        this.room.metadata[key] = val
      }
    },
    isSelectDisabled(): boolean {
      if (!this.settingsPage) return false
      return !this.profile.subscription || this.profile.subscription.id !== this.room.subscription.id
    },
  },
  async mounted() {
    try {
      let data;

      if (!this.settingsPage) {
        ({data} = await roomsService.getMetadata())
      } else {
        ({data} = await roomsService.getRoomMetadata(this.mnemo))
      }

      this.metadata = data.metadata
    } catch (error) {
      console.error('Failed to fetch metadata:', error)
    } finally {
      this.metadataSelectGroupPending = false
    }
  },
}
</script>
